<div class="checkout-slide">
  <div class="row d-none d-md-block my-3">
    <div class="col-md-6">
      <div class="title" i18n>{{ title | titlecase }}</div>
    </div>
  </div>
  <form [formGroup]="personalInfoFormGroup" (ngSubmit)="next(2)" autocomplete="off">
    <div [formGroupName]="BillingCustomer">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <app-text-field-input
              [identifier]="FirstName"
              label="First name"
              i18n-label
              placeholder="Your first name goes here"
              i18n-placeholder
              [formControlName]="FirstName"
              [readonly]="isAuthenticated$ | async"
            >
            </app-text-field-input>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <app-text-field-input
              [identifier]="LastName"
              label="Last name"
              i18n-label
              placeholder="Your last name goes here"
              i18n-placeholder
              [formControlName]="LastName"
              [readonly]="isAuthenticated$ | async"
            >
            </app-text-field-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <h6 class="card-title mb-2" i18n>Preferred Method of Contact</h6>
          <div *ngIf="(isAuthenticated$ | async) === false">
            <p class="text-muted mb-3" i18n>
              Choose how we’ll contact you. You’ll also use this to log in if you create an account
              after the order is submitted.
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <input
            class="radio-input"
            type="radio"
            id="contactPhone"
            formControlName="contactMethod"
            value="phone"
            (click)="onContactMethodClick('phone')"
            [disabled]="contactMethodCtrl?.disabled"
          />
          <label class="label" for="contactPhone" i18n> Mobile Phone #</label>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <input
            class="radio-input"
            type="radio"
            id="contactEmail"
            formControlName="contactMethod"
            (click)="onContactMethodClick('email')"
            value="email"
            [disabled]="contactMethodCtrl?.disabled"
          />
          <label class="label" for="contactEmail" i18n> Email Address</label>
        </div>
      </div>

      <div>
        <div [hidden]="!isPhoneNumberAdded">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <app-text-field-input
                  #phoneNumber
                  [identifier]="PhoneNumber"
                  label="Mobile number"
                  i18n-label
                  placeholder="Your phone number goes here"
                  i18n-placeholder
                  formControlName="phoneNumber"
                  type="tel"
                  [formErrorMessages]="phoneErrorMessages"
                  [isDataPrivate]="true"
                  [readonly]="isAuthenticated$ | async"
                  [disabled]="personalInfoFormGroup.get('billingCustomer.phoneNumber')?.disabled"
                >
                </app-text-field-input>
                <div
                  *ngIf="(userPrincipalErrorType$ | async) === PhErrorTypes.UserPrincipal"
                  class="col-12 validation-error-message mb-2"
                >
                  <span id="phone-error-message" i18n>
                    This phone number cannot be used in Ecommerce because it is already registered!
                  </span>
                </div>

                <div
                  *ngIf="showPhoneRequiredMessage"
                  class="col-12 validation-error-message mb-2 pl-0"
                >
                  <span id="phone-required-message" i18n>
                    Please enter your mobile phone number to proceed.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div [hidden]="!isEmailAddressAdded">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <app-text-field-input
                  #emailInput
                  [identifier]="Email"
                  type="email"
                  label="Email address"
                  i18n-label
                  placeholder="Your email address goes here"
                  i18n-placeholder
                  [formControlName]="Email"
                  [readonly]="isAuthenticated$ | async"
                  [isDataPrivate]="true"
                >
                </app-text-field-input>
                <div
                  *ngIf="(emailErrorType$ | async) === PhErrorTypes.Email"
                  class="validation-error-message mt-1"
                >
                  <span id="email-error-message" i18n>
                    This e-mail cannot be used in Ecommerce because it is already registered on a PH
                    consultant!
                  </span>
                </div>
                <div *ngIf="showEmailRequiredMessage" class="validation-error-message mt-1">
                  <span id="email-required-message" i18n>
                    Please enter your email address to proceed.
                  </span>
                </div>
              </div>
            </div>

            <div class="col-md-6" *ngIf="(isAuthenticated$ | async) === false">
              <div class="form-group">
                <app-text-field-input
                  #emailConfirmInput
                  [identifier]="EmailConfirm"
                  type="email"
                  label="Re-enter email address"
                  i18n-label
                  [groupValidationErrorType]="FormErrorTypes.emailConfirm"
                  placeholder="Your email address goes here"
                  i18n-placeholder
                  [formControlName]="EmailConfirm"
                  [isDataPrivate]="true"
                >
                </app-text-field-input>
                <div *ngIf="showEmailConfirmRequiredMessage" class="validation-error-message mt-1">
                  <span id="email-confirm-required-message" i18n>
                    Please re-enter your email address to proceed.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div
              *ngIf="
                (isAuthenticated$ | async) === false &&
                (!isEmailAddressAdded || !isPhoneNumberAdded)
              "
            >
              <div class="row">
                <div class="col-md-6">
                  <button class="btn btn-call" (click)="addContact()" i18n>
                    <img class="icon" src="assets/images/icons/addcontact.svg" /> ADD ANOTHER
                    CONTACT METHOD
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row mt-3"
          *ngIf="showSmsConsent && (contactMethodCtrl?.value === 'phone' || isPhoneNumberAdded)"
        >
          <div class="col">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                [formControlName]="SmsTransactionalConsent"
                id="smsTransactionalConsent"
              />
              <label i18n class="form-check-label" for="smsTransactionalConsent">
                By checking this box, you expressly consent to receiving recurring
                transactional/informational text messages from Princess House. Message frequency may
                vary. Data rates may apply based on your carrier. You can opt out at any time by
                replying STOP to any text message. This is required to receive support on your
                Princess House transaction.
              </label>
            </div>
          </div>
        </div>
        <div
          class="row mt-2"
          *ngIf="showSmsConsent && (contactMethodCtrl?.value === 'phone' || isPhoneNumberAdded)"
        >
          <div class="col">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                [formControlName]="SmsMarketingConsent"
                id="smsPromotionalConsent"
              />
              <label i18n class="form-check-label" for="smsPromotionalConsent">
                Check this box if you consent to receive promotional and marketing messages from
                Princess House in addition to transactional messages.
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3 mb-3" *ngIf="showContactInfoRequiredAlert">
          <div class="col">
            <div class="contact-info-required-alert">
              <i class="bi bi-exclamation-circle-fill alert-icon"></i>
              <div class="alert-content">
                <div class="alert-title" i18n>Contact information required</div>
                <p class="mb-1" i18n>To continue, please either:</p>
                <ul class="mb-0">
                  <li i18n>Check the box to receive order updates by text message, or</li>
                  <li i18n>Enter a valid email address.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row mt-3"
          *ngIf="
            (contactMethodCtrl?.value === 'email' || isEmailAddressAdded) &&
            !((isAuthenticated$ | async) === true && (isNewsLetterSubscribe$ | async) === true)
          "
        >
          <div class="col">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                [formControlName]="Updates"
                id="updates"
              />
              <label i18n class="form-check-label" for="updates">
                Receive future updates from Princess House about new products and promotions.
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3 mb-3" *ngIf="contactMethodCtrl?.value === 'email' || isEmailAddressAdded">
          <div class="col">
            <strong class="contact-disclaimer" i18n>Princess House will email you with updates on shipping and other transactional messages.</strong>
          </div>
        </div>
      </div>
    </div>

    <app-shipping-address-form
      i18n-title
      title="Shipping address"
      [countryStates$]="countryStates$"
      [isAuthenticated]="isAuthenticated$ | async"
      [addressVerification]="shippingAddressVerification$ | async"
      [showCheckbox]="showNameCheckbox"
      id="ShippingAddress"
      (addressChange)="changeAddress()"
      (toggleShippingName)="toggleShippingName($event)"
      #address
    ></app-shipping-address-form>

    <div class="row">
      <div class="col validation-error-message my-2" *ngIf="addressErrorType$ | async as errorType">
        {{ ErrorMessages[errorType] }}
      </div>
    </div>

    <div class="row mb-2">
      <div class="col">
        <app-address-validation
          [addressValidation$]="shippingAddressVerification$"
          [countryStates$]="countryStates$"
          [finalizeAddress]="saveShippingAddressForm"
          [onDismiss]="onDismissShippingAddress"
        >
        </app-address-validation>
      </div>
    </div>

    <div class="row justify-content-between">
      <div class="col col-md-5">
        <button
          class="btn btn-outline-dark text-uppercase w-100"
          i18n
          [routerLink]="'/' + ShippingCartRoute"
          [disabled]="disableButton$ | async"
          >Back to Cart
        </button>
      </div>
      <div class="col col-md-5">
        <button
          type="submit"
          class="btn btn-primary text-uppercase w-100"
          i18n
          [disabled]="disableButton$ | async"
          >Continue
        </button>
      </div>
    </div>
  </form>
</div>

<app-my-address-popup
  [userAddresses]="userAddresses$ | async"
  [currentAddress$]="currentAddress$"
  [onDismiss]="dismissSavedAddressesModal"
  (addressSelect)="selectAddress($event)"
></app-my-address-popup>

<ng-container *ngIf="(isAuthenticated$ | async) === false && showLoginModal">
  <app-login-modal
    [isAuthenticated$]="isAuthenticated$"
    [email]="loginEmail"
    #loginModal
  ></app-login-modal>
</ng-container>
